import React from 'react';
import PrimaryButton from "../components/buttons/PrimaryButton";

function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen background-gradient">
      <h1 className="text-6xl font-bold text-gray-800">404</h1>
      <p className="mt-4 text-lg text-gray-600">Oops! The page you're looking for doesn't exist.</p>
      <PrimaryButton
        to="/"
        className="mt-6"
      >
        Go back to Home
      </PrimaryButton>
    </div>
  );
}

export default NotFoundPage;
